import Vue from 'vue';
import header from 'outlook/components/marketHighlights/header';
import releaseCalendar from 'outlook/components/hubPage/releaseCalendar';
import highlightsNavigation from 'outlook/components/marketHighlights/highlightsNavigation';
import { getFromTemplate } from 'tools/getFromHtml';
import { getFormFields } from 'tools/formFieldData';
import { ICONS } from 'outlook/constants/constants';
import { marketHighlightsStore } from 'outlook/store/marketHighlightsStore';
import { doAjaxRequest, AXIOS_REQUEST_TYPES, AXIOS_RESPONSE_TYPES } from 'outlook/utils/doAxiosRequest';

const formFields = getFormFields('[data-vue-market-highlights-search]', null, false);
const marketHighlightsElement = document.querySelector('[data-vue-market-highlights-search]');
const highlightsNavigationElement = document.querySelector('[data-vue-xmo-navigation]');

const LOCALE_DE = 'de';
const LOCALE_EN = 'en';
const CONTENT_LOCALE = window.stGlobals.locale === LOCALE_DE ? LOCALE_DE : LOCALE_EN;
const marketData = JSON.parse(getFromTemplate('var', 'marketData'));
const marketDirectory = JSON.parse(getFromTemplate('var', 'marketDirectory'));

if (highlightsNavigationElement) {
    new Vue({
        el: highlightsNavigationElement,
        store: marketHighlightsStore,
        render(createElement) {
            return createElement(highlightsNavigation, {
                props: {
                    marketData,
                    locale: CONTENT_LOCALE,
                },
            });
        },
    });
}

if (marketHighlightsElement) {
    new Vue({
        el: marketHighlightsElement,
        store: marketHighlightsStore,
        render(createElement) {
            return createElement(header, {
                props: {
                    marketData,
                    marketDirectory,
                    locale: CONTENT_LOCALE,
                    imageLocale: CONTENT_LOCALE,
                    filterForm: formFields,
                    icons: ICONS,
                    formName: `${ formFields.q.name }--marketHighlightsSearch`,
                },
            });
        },
    });
}

const releaseCalendarElement = document.querySelector('[data-vue-releases]');
if (releaseCalendarElement) {
    new Vue({
        el: releaseCalendarElement,
        store: marketHighlightsStore,
        data() {
            return {
                isXMONewsAvailable: false,
            };
        },
        methods: {
            getData() {
                const url = '/news-feed-slider';
                doAjaxRequest(AXIOS_REQUEST_TYPES.GET, url, { type: 'XMO' })
                    .then(({ status, data }) => {
                        if (status === AXIOS_RESPONSE_TYPES.OK) {
                            this.isXMONewsAvailable = Array.isArray(data) && data?.length > 1;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
        },
        created() {
            this.getData();
        },
        render(createElement) {
            return createElement(releaseCalendar, {
                props: {
                    isNewsAvailable: this.isXMONewsAvailable,
                    canShowMarketFilter: true,
                    locale: CONTENT_LOCALE,
                },
            });
        },
    });
}
